<div class="ui-g">
  <div class=" ui-sm-12 ui-md-6 ui-md-offset-3 ui-lg-5 ui-lg-offset-4 ui-xl-4 ui-xl-offset-4">
      <app-forgot-password></app-forgot-password>
  </div>
</div>
